class Radios extends HTMLElement {
  constructor() { 
    super(); 
    this.activeRadio = null; // Variable para rastrear el radio activo
    // Preparar los handlers enlazados al contexto
    this._onClick = this._onClick?.bind ? this._onClick.bind(this) : null;
    this._onChange = this._onChange?.bind ? this._onChange.bind(this) : null;
  }

  // Añadimos listeners cuando el custom element entra al DOM
  connectedCallback() {
    this.addEventListener('click', this._onClick);
    this.addEventListener('change', this._onChange);
  }

  // Limpiamos listeners al salir del DOM
  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener('change', this._onChange);
  }

  // Maneja clic en el swatch (label con data-item="swatch")
  _onClick(e) {
    const swatch = e.target.closest('[data-item="swatch"]');
    if (!swatch || !this.contains(swatch)) return;

    const forId = swatch.getAttribute('for');
    let input = null;
    if (forId) {
      try {
        input = this.querySelector(`#${CSS && CSS.escape ? CSS.escape(forId) : forId}`);
      } catch (_) {
        input = this.querySelector(`[id="${forId}"]`);
      }
    }

    const color = input?.value || swatch.getAttribute('aria-label') || '';
    if (!color) return;

    if (input) input.checked = true;
    this._setActiveSwatch(swatch);
    this._showGroupForColor(color);
  }

  // Maneja cambio del input radio (por accesibilidad/teclado)
  _onChange(e) {
    const input = e.target;
    if (!input || !input.matches('.radios--input')) return;

    const color = input.value;
    const swatch = this.querySelector(`[data-item="swatch"][for="${input.id}"]`);
    if (swatch) this._setActiveSwatch(swatch);
    this._showGroupForColor(color);
  }

  // Marca visualmente el swatch activo
  _setActiveSwatch(swatchEl) {
    this.querySelectorAll('.radios--swatch-button.active').forEach(el => el.classList.remove('active'));
    swatchEl.classList.add('active');
  }

  // Muestra el grupo de tallas del color seleccionado y oculta los demás
  _showGroupForColor(color) {
    const colorNorm = (color || '').trim().toLowerCase();
    const card = this.closest('.card') || this.closest('.card-wrapper') || document;
    const groups = card.querySelectorAll('.card__variants-group');
    if (!groups.length) return;

    groups.forEach(group => {
      const gc = (group.dataset.color || '').trim().toLowerCase();
      const isMatch = gc === colorNorm;
      group.classList.toggle('is-visible', isMatch);
      group.classList.toggle('hidden', !isMatch);
    });

    // Además: alternar el slider (card__media) por color
    const medias = card.querySelectorAll('.card__media[color-option]');
    if (medias && medias.length) {
      let matchedMedia = null;
      medias.forEach(media => {
        const mediaColor = (media.getAttribute('color-option') || '').trim().toLowerCase();
        const isMatch = mediaColor === colorNorm;
        media.classList.toggle('hidden', !isMatch);
        if (isMatch) matchedMedia = media;
      });

      // Si se encontró el media del color, reseteamos el slider y forzamos update
      if (matchedMedia) {
        const scroller =
          matchedMedia.querySelector('.slider') ||
          matchedMedia.querySelector('.slider--everywhere');

        try {
          if (scroller) {
            scroller.scrollTo({ left: 0, behavior: 'auto' });
            // Forzar que el componente Slider actualice estados de botones
            requestAnimationFrame(() => {
              scroller.dispatchEvent(new Event('scroll', { bubbles: true }));
            });
          }
        } catch (_) {
          // No romper en caso de navegadores antiguos
          if (scroller) {
            scroller.scrollLeft = 0;
            scroller.dispatchEvent(new Event('scroll', { bubbles: true }));
          }
        }
      }
    }
  }
}

customElements.define("radios-root", Radios);